import { OrderHistory } from '@/feature/order_entry/ViewOrder';
import { createHistoryStore } from '@/components/datagrid';
import { Side } from '@/common/constants';

export const useOrderHistoryStore = createHistoryStore<OrderHistory, string>({
  devtoolsName: 'dex-order-history',
  getKey: (o: OrderHistory) => o.uniqueId,
  applyQuickFilter: (row, quick) => {
    if (quick === 'market') return true;
    if (quick === 'buy') return !!row.isBuy;
    if (quick === 'sell') return !row.isBuy;
    return row.side === (quick as Side);
  },
  getMarketId: (row) => row.marketId,
});
